var map = {
	"./angbao-bonus-thaipusam.webp": 2493,
	"./angbao-bonus.webp": 2494,
	"./angbao-bonus_dewali.webp": 2495,
	"./cny-lucky-draw.webp": 2496,
	"./cny-promo.webp": 2497,
	"./dewali-promo.webp": 2498,
	"./fifa-logo.webp": 2499,
	"./fifa-prediction.webp": 2500,
	"./fifa-qna.webp": 2501,
	"./raya-promo.webp": 2502,
	"./welcome-cny-bonus.webp": 2503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2492;